<!-- [ngClass]="{
  'workspace-popup-first-time__switch': workspaceSwitchTour,
  'workspace-popup-first-time__activity-log': activityLogTour,
  'workspace-popup-first-time__upgraded': upgraded,
  'workspace-popup-first-time__has-switcher': hasSwitch,
  'workspace-popup-first-time__switch-invited': invited}" -->
  <!-- TODO  update fix -->
<div class="workspace-popup-first-time">
  <div class="workspace-popup-first-time__close" *ngIf="hasCloseButton" (click)="gotIt(true)">
    <i class="db-icon db-icon-chat-close"></i>
  </div>
  <div class="workspace-popup-first-time__title">
    <p [innerHTML]="title" ></p>
  </div>
  <div class="workspace-popup-first-time__desc">
    <p [innerHTML]="desc" ></p>
  </div>
  <div class="db-buttons workspace-popup-first-time__button">
    <a class="db-button db-button_info" (click)="gotIt()">
      <span [innerHTML]="buttonText1"></span>
    </a>
    <a class="db-button db-button_info" (click)="gotIt(false, true)" *ngIf="buttonText2">
      <span [innerHTML]="buttonText2"></span>
    </a>
  </div>
</div>
<div class="workspace-popup-first-time__page-block"></div>
